import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CompanyCalendar from './CompanyCalendar';
import CompanyAnalytics from './CompanyAnalytics';

const AppointmentsTab = ({ companyId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', appointment_date: '', status: 'pending' });

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/appointments`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setData(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [companyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/admin/companies/${companyId}/appointments`, form, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setForm({ title: '', description: '', appointment_date: '', status: 'pending' });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-appointments/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleStatus = async (id, currentData, newStatus) => {
    try {
      await axios.put(`/api/admin/company-appointments/${id}`, { ...currentData, status: newStatus }, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      fetchData();
    } catch (e) { console.error(e); }
  };

  return (
    <div className="company-detail-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px', color: '#fff' }}>
      <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', borderRadius: '12px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>Yeni Randevu Ekle</h3>
        <form onSubmit={handleSubmit} className="form-group" style={{ marginBottom: 0 }}>
          <input required type="text" placeholder="Başlık" value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={inputStyle} />
          <textarea placeholder="Açıklama" value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={{...inputStyle, height: '80px'}} />
          <input required type="datetime-local" value={form.appointment_date} onChange={e => setForm({...form, appointment_date: e.target.value})} style={inputStyle} />
          <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} style={inputStyle}>
            <option value="pending">Bekliyor</option>
            <option value="completed">Tamamlandı</option>
            <option value="cancelled">İptal Edildi</option>
          </select>
          <button type="submit" style={btnStyle}>Ekle</button>
        </form>
      </div>
      <div style={{ overflowX: 'auto' }}>
        {loading ? <p>Yükleniyor...</p> : (
          <table style={tableStyle}>
            <thead><tr><th>Tarih</th><th>Başlık</th><th>Durum</th><th>İşlem</th></tr></thead>
            <tbody>
              {data.map(d => (
                <tr key={d.id}>
                  <td>{new Date(d.appointment_date).toLocaleString('tr-TR')}</td>
                  <td>{d.title}</td>
                  <td>
                    <select value={d.status} onChange={e => handleStatus(d.id, d, e.target.value)} style={{...inputStyle, padding:'4px', width:'auto', marginBottom:0}}>
                      <option value="pending">Bekliyor</option>
                      <option value="completed">Tamamlandı</option>
                      <option value="cancelled">İptal Edildi</option>
                    </select>
                  </td>
                  <td><button onClick={() => handleDelete(d.id)} style={delBtnStyle}>Sil</button></td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan="4" style={{textAlign:'center'}}>Kayıt yok.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const ShootingSchedulesTab = ({ companyId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ title: '', location: '', schedule_date: '' });

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/shooting-schedules`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setData(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [companyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`/api/admin/companies/${companyId}/shooting-schedules`, form, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setForm({ title: '', location: '', schedule_date: '' });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-shooting-schedules/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      fetchData();
    } catch (e) { console.error(e); }
  };

  return (
    <div className="company-detail-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px', color: '#fff' }}>
      <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', borderRadius: '12px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>Yeni Çekim Ekle</h3>
        <form onSubmit={handleSubmit} className="form-group" style={{ marginBottom: 0 }}>
          <input required type="text" placeholder="Başlık" value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={inputStyle} />
          <input required type="text" placeholder="Konum" value={form.location} onChange={e => setForm({...form, location: e.target.value})} style={inputStyle} />
          <input required type="datetime-local" value={form.schedule_date} onChange={e => setForm({...form, schedule_date: e.target.value})} style={inputStyle} />
          <button type="submit" style={{...btnStyle, background:'linear-gradient(135deg, var(--secondary), var(--tertiary))'}}>Planla</button>
        </form>
      </div>
      <div style={{ overflowX: 'auto' }}>
        {loading ? <p>Yükleniyor...</p> : (
          <table style={tableStyle}>
            <thead><tr><th>Tarih</th><th>Başlık</th><th>Konum</th><th>İşlem</th></tr></thead>
            <tbody>
              {data.map(d => (
                <tr key={d.id}>
                  <td>{new Date(d.schedule_date).toLocaleString('tr-TR')}</td>
                  <td>{d.title}</td>
                  <td>{d.location}</td>
                  <td><button onClick={() => handleDelete(d.id)} style={delBtnStyle}>Sil</button></td>
                </tr>
              ))}
              {data.length === 0 && <tr><td colSpan="4" style={{textAlign:'center'}}>Kayıt yok.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const FinancesTab = ({ companyId }) => {
  const [data, setData] = useState({ records: [], summary: { total_income: 0, total_expense: 0, balance: 0 } });
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ type: 'income', amount: '', description: '', transaction_date: new Date().toISOString().split('T')[0], is_installment: false, installment_count: '', installment_total_amount: '', payment_card_id: '' });
  const [file, setFile] = useState(null);
  const [advancingId, setAdvancingId] = useState(null);
  const [cards, setCards] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/finances`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setData(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const fetchCards = async () => {
    try {
      const res = await axios.get('/api/admin/company-payment-cards', { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setCards(res.data.filter(c => c.is_active));
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetchData(); fetchCards(); }, [companyId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let invoice_path = null;
      let invoice_name = null;

      if (file) {
        const formData = new FormData();
        formData.append('file', file);
        const uploadRes = await axios.post('/api/admin/company-finances/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
        });
        invoice_path = uploadRes.data.invoice_path;
        invoice_name = uploadRes.data.invoice_name;
      }

      await axios.post(`/api/admin/companies/${companyId}/finances`, {
        ...form,
        invoice_path,
        invoice_name
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });

      setForm({ ...form, amount: '', description: '', is_installment: false, installment_count: '', installment_total_amount: '', payment_card_id: '' });
      setFile(null);
      const fileInput = document.getElementById('finance-file-input');
      if (fileInput) fileInput.value = '';

      fetchData();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-finances/${id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleAdvanceInstallment = async (id) => {
    try {
      setAdvancingId(id);
      await axios.post(`/api/admin/company-finances/${id}/advance-installment`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      fetchData();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message));
    } finally {
      setAdvancingId(null);
    }
  };

  const handleViewInvoice = async (invoicePath) => {
    try {
      const res = await axios.get(invoicePath, {
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
        responseType: 'blob'
      });
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    } catch (e) {
      alert('Dosya yüklenirken hata oluştu.');
    }
  };

  return (
    <div className="company-detail-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px', color: '#fff' }}>
      <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', borderRadius: '12px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>Finans Kaydı Ekle</h3>
        <form onSubmit={handleSubmit} className="form-group" style={{ marginBottom: 0 }}>
          <select value={form.type} onChange={e => setForm({...form, type: e.target.value, is_installment: e.target.value === 'expense' ? form.is_installment : false})} style={inputStyle}>
            <option value="income">Gelir (+)</option>
            <option value="expense">Gider (-)</option>
          </select>

          {form.type === 'expense' && (
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: '12px', fontSize: '13px', color: '#E5E7EB' }}>
              <input
                type="checkbox"
                checked={form.is_installment}
                onChange={e => setForm({ ...form, is_installment: e.target.checked })}
                style={{ width: 15, height: 15, accentColor: '#EF4444' }}
              />
              Taksitli Ödeme
            </label>
          )}

          {form.type === 'expense' && (
            <select value={form.payment_card_id} onChange={e => setForm({ ...form, payment_card_id: e.target.value })} style={inputStyle}>
              <option value="">Hangi Karttan/Hesaptan Ödendi? (Opsiyonel)</option>
              {cards.map(c => (
                <option key={c.id} value={c.id}>{c.label}{c.last4 ? ` ****${c.last4}` : ''}{c.bank_name ? ` - ${c.bank_name}` : ''}</option>
              ))}
            </select>
          )}

          {form.is_installment ? (
            <>
              <input required type="number" step="0.01" min="0.01" placeholder="Toplam Tutar" value={form.installment_total_amount} onChange={e => setForm({...form, installment_total_amount: e.target.value})} style={inputStyle} />
              <input required type="number" step="1" min="1" placeholder="Taksit Sayısı" value={form.installment_count} onChange={e => setForm({...form, installment_count: e.target.value})} style={inputStyle} />
              <div style={{ ...inputStyle, background: 'rgba(239,68,68,0.08)', border: '1px dashed rgba(239,68,68,0.3)', color: '#FCA5A5' }}>
                Aylık Taksit Ödemesi: {(() => {
                  const total = parseFloat(form.installment_total_amount) || 0;
                  const count = parseInt(form.installment_count, 10) || 0;
                  return count > 0 ? (Math.round((total / count) * 100) / 100) : 0;
                })()} ₺
              </div>
            </>
          ) : (
            <input required type="number" step="0.01" placeholder="Tutar" value={form.amount} onChange={e => setForm({...form, amount: e.target.value})} style={inputStyle} />
          )}
          <input required type="text" placeholder="Açıklama" value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={inputStyle} />
          <input required type="date" value={form.transaction_date} onChange={e => setForm({...form, transaction_date: e.target.value})} style={inputStyle} />
          
          <label style={{ display: 'block', color: '#9CA3AF', fontSize: '12px', marginBottom: '6px' }}>Fatura / Belge (Opsiyonel)</label>
          <input id="finance-file-input" type="file" onChange={e => setFile(e.target.files[0])} style={{ ...inputStyle, background: 'transparent', border: 'none', padding: 0 }} />
          
          <button type="submit" style={btnStyle}>Kaydet</button>
        </form>
        
        <div style={{ marginTop: '24px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}><span style={{ color:'#9CA3AF' }}>Toplam Gelir:</span> <strong style={{ color:'#10B981' }}>{data.summary.total_income} ₺</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}><span style={{ color:'#9CA3AF' }}>Toplam Gider:</span> <strong style={{ color:'#EF4444' }}>{data.summary.total_expense} ₺</strong></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px', fontSize: '16px' }}><span style={{ color:'#fff' }}>Bakiye:</span> <strong style={{ color: data.summary.balance >= 0 ? '#10B981' : '#EF4444' }}>{data.summary.balance} ₺</strong></div>
        </div>
      </div>
      <div style={{ overflowX: 'auto' }}>
        {loading ? <p>Yükleniyor...</p> : (
          <table style={tableStyle}>
            <thead><tr><th>Tarih</th><th>Açıklama</th><th>Tutar</th><th>Fatura</th><th>İşlem</th></tr></thead>
            <tbody>
              {data.records.map(d => (
                <tr key={d.id}>
                  <td>{new Date(d.transaction_date).toLocaleDateString('tr-TR')}</td>
                  <td>
                    {d.description}
                    {!!d.payment_card_label && (
                      <div style={{ marginTop: 4 }}>
                        <span style={{ fontSize: 11, fontWeight: 600, color: '#93C5FD', background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)', borderRadius: 6, padding: '2px 8px' }}>
                          💳 {d.payment_card_label}
                        </span>
                      </div>
                    )}
                    {!!d.is_installment && (
                      <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 11, fontWeight: 700, color: '#FCA5A5', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 6, padding: '2px 8px' }}>
                          Taksit {d.current_installment}/{d.installment_count}
                        </span>
                        <span style={{ fontSize: 11, color: '#9CA3AF' }}>Toplam: {d.installment_total_amount} ₺</span>
                        {d.current_installment < d.installment_count && (
                          <button
                            onClick={() => handleAdvanceInstallment(d.id)}
                            disabled={advancingId === d.id}
                            style={{ fontSize: 11, padding: '2px 8px', background: 'rgba(59,130,246,0.12)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.25)', borderRadius: 6, cursor: 'pointer' }}
                          >
                            {advancingId === d.id ? '...' : '▶ Sonraki Taksite Geç'}
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                  <td style={{ color: d.type === 'income' ? '#10B981' : '#EF4444', fontWeight: 600 }}>{d.type === 'income' ? '+' : '-'}{d.amount} ₺{d.is_installment ? ' /ay' : ''}</td>
                  <td>
                    {d.invoice_path ? (
                      <button
                        onClick={() => handleViewInvoice(d.invoice_path)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#60A5FA',
                          cursor: 'pointer',
                          padding: 0,
                          fontSize: '14px',
                          textDecoration: 'underline',
                          textAlign: 'left'
                        }}
                      >
                        📄 {d.invoice_name || 'Faturayı Gör'}
                      </button>
                    ) : (
                      <span style={{ color: '#6B7280' }}>Yok</span>
                    )}
                  </td>
                  <td><button onClick={() => handleDelete(d.id)} style={delBtnStyle}>Sil</button></td>
                </tr>
              ))}
              {data.records.length === 0 && <tr><td colSpan="5" style={{textAlign:'center'}}>Kayıt yok.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

const ACTIVITY_ICONS = {
  create: '➕',
  update: '✏️',
  delete: '🗑️',
  advance_installment: '▶️',
  reveal: '👁️'
};

const TASK_STATUS_COLUMNS = [
  { id: 'todo', title: 'Yapılacak', color: '#94A3B8' },
  { id: 'in_progress', title: 'Devam Ediyor', color: '#3B82F6' },
  { id: 'done', title: 'Tamamlandı', color: '#10B981' }
];

const TasksTab = ({ companyId }) => {
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [form, setForm] = useState({ title: '', description: '', assigned_to: '', due_date: '', status: 'todo' });

  const authHeader = { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } };

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/tasks`, authHeader);
      setTasks(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const fetchUsers = async () => {
    try {
      const res = await axios.get('/api/admin/users', authHeader);
      setUsers(res.data);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetchTasks(); fetchUsers(); }, [companyId]);

  const resetForm = () => setForm({ title: '', description: '', assigned_to: '', due_date: '', status: 'todo' });

  const openNewForm = () => { setEditingTask(null); resetForm(); setShowForm(true); };
  const openEditForm = (task) => {
    setEditingTask(task);
    setForm({
      title: task.title,
      description: task.description || '',
      assigned_to: task.assigned_to || '',
      due_date: task.due_date ? String(task.due_date).split('T')[0] : '',
      status: task.status
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingTask) {
        await axios.put(`/api/admin/company-tasks/${editingTask.id}`, form, authHeader);
      } else {
        await axios.post(`/api/admin/companies/${companyId}/tasks`, form, authHeader);
      }
      setShowForm(false);
      setEditingTask(null);
      resetForm();
      fetchTasks();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu görevi silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-tasks/${id}`, authHeader);
      setShowForm(false);
      fetchTasks();
    } catch (e) { console.error(e); }
  };

  const handleDragStart = (e, taskId) => {
    e.dataTransfer.setData('taskId', String(taskId));
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = async (e, targetStatus) => {
    const taskId = parseInt(e.dataTransfer.getData('taskId'), 10);
    const task = tasks.find(t => t.id === taskId);
    if (!task || task.status === targetStatus) return;

    const previousTasks = tasks;
    const updatedTasks = tasks.map(t => t.id === taskId ? { ...t, status: targetStatus } : t);
    setTasks(updatedTasks);

    const sourceIds = updatedTasks.filter(t => t.status === task.status).map(t => t.id);
    const targetIds = updatedTasks.filter(t => t.status === targetStatus).map(t => t.id);

    try {
      await axios.put(`/api/admin/companies/${companyId}/tasks/reorder`, {
        columns: { [task.status]: sourceIds, [targetStatus]: targetIds }
      }, authHeader);
    } catch (err) {
      console.error('Görev taşıma hatası, geri alınıyor:', err);
      setTasks(previousTasks);
    }
  };

  const isOverdue = (dueDate, status) => dueDate && status !== 'done' && new Date(dueDate) < new Date(new Date().toDateString());

  return (
    <div style={{ color: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, fontSize: '15px' }}>🗂️ Ekip İş Takip Panosu</h3>
        <button onClick={openNewForm} style={{ padding: '8px 16px', background: 'linear-gradient(135deg, #06B6D4, #0891B2)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>
          + Yeni Görev
        </button>
      </div>

      {loading ? <p>Yükleniyor...</p> : (
        <div className="company-kanban-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
          {TASK_STATUS_COLUMNS.map(col => {
            const colTasks = tasks.filter(t => t.status === col.id);
            return (
              <div key={col.id} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, col.id)} style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '12px', padding: '12px', minHeight: '300px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: col.color, boxShadow: `0 0 8px ${col.color}` }}></span>
                  <strong style={{ fontSize: '13px', color: '#E5E7EB' }}>{col.title}</strong>
                  <span style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.08)', color: '#9CA3AF', fontSize: '11px', padding: '2px 8px', borderRadius: '10px' }}>{colTasks.length}</span>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {colTasks.length === 0 && <div style={{ textAlign: 'center', color: '#4B5563', fontSize: '12px', padding: '20px 0' }}>Görev yok</div>}
                  {colTasks.map(task => (
                    <div
                      key={task.id}
                      draggable
                      onDragStart={(e) => handleDragStart(e, task.id)}
                      onClick={() => openEditForm(task)}
                      style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px', padding: '12px', cursor: 'grab' }}
                    >
                      <div style={{ fontSize: '13px', fontWeight: 600, color: '#fff', marginBottom: '6px' }}>{task.title}</div>
                      {task.description && <div style={{ fontSize: '12px', color: '#9CA3AF', marginBottom: '8px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{task.description}</div>}
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                        {task.assigned_username && (
                          <span style={{ fontSize: '11px', color: '#93C5FD', background: 'rgba(59,130,246,0.12)', border: '1px solid rgba(59,130,246,0.25)', borderRadius: '6px', padding: '2px 8px' }}>
                            👤 {task.assigned_username}
                          </span>
                        )}
                        {task.due_date && (
                          <span style={{ fontSize: '11px', color: isOverdue(task.due_date, task.status) ? '#FCA5A5' : '#9CA3AF', background: isOverdue(task.due_date, task.status) ? 'rgba(239,68,68,0.12)' : 'rgba(255,255,255,0.06)', border: `1px solid ${isOverdue(task.due_date, task.status) ? 'rgba(239,68,68,0.25)' : 'rgba(255,255,255,0.1)'}`, borderRadius: '6px', padding: '2px 8px' }}>
                            📅 {new Date(task.due_date).toLocaleDateString('tr-TR')}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div onClick={() => setShowForm(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#1A1A24', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '24px', width: '420px', maxWidth: '90vw' }}>
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>{editingTask ? 'Görevi Düzenle' : 'Yeni Görev'}</h3>
            <form onSubmit={handleSubmit}>
              <input required type="text" placeholder="Başlık" value={form.title} onChange={e => setForm({...form, title: e.target.value})} style={inputStyle} />
              <textarea placeholder="Açıklama" value={form.description} onChange={e => setForm({...form, description: e.target.value})} style={{...inputStyle, height: '70px'}} />
              <select value={form.assigned_to} onChange={e => setForm({...form, assigned_to: e.target.value})} style={inputStyle}>
                <option value="">Atanan Kişi (Opsiyonel)</option>
                {users.map(u => <option key={u.id} value={u.id}>{u.username}</option>)}
              </select>
              <input type="date" value={form.due_date} onChange={e => setForm({...form, due_date: e.target.value})} style={inputStyle} />
              <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} style={inputStyle}>
                <option value="todo">Yapılacak</option>
                <option value="in_progress">Devam Ediyor</option>
                <option value="done">Tamamlandı</option>
              </select>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button type="submit" style={{...btnStyle, background: 'linear-gradient(135deg, #06B6D4, #0891B2)'}}>{editingTask ? 'Güncelle' : 'Ekle'}</button>
                {editingTask && <button type="button" onClick={() => handleDelete(editingTask.id)} style={{...delBtnStyle, width: 'auto', padding: '10px 16px'}}>Sil</button>}
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const DOC_ICONS = {
  'application/pdf': '📕',
  'image/jpeg': '🖼️', 'image/png': '🖼️', 'image/webp': '🖼️', 'image/gif': '🖼️',
  'application/msword': '📄', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '📄',
  'application/vnd.ms-excel': '📊', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '📊'
};

const formatFileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / 1024 / 1024).toFixed(1) + ' MB';
};

const DocumentsTab = ({ companyId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState('');
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const authHeader = { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/documents`, authHeader);
      setData(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, [companyId]);

  const handleUpload = async (e) => {
    e.preventDefault();
    if (files.length === 0) return;
    try {
      setUploading(true);
      const formData = new FormData();
      files.forEach(f => formData.append('files', f));
      if (label) formData.append('label', label);
      await axios.post(`/api/admin/companies/${companyId}/documents/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${localStorage.getItem('admin_token')}` }
      });
      setLabel('');
      setFiles([]);
      const fileInput = document.getElementById('company-doc-file-input');
      if (fileInput) fileInput.value = '';
      fetchData();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message));
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu evrakı silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-documents/${id}`, authHeader);
      fetchData();
    } catch (e) { console.error(e); }
  };

  const handleView = async (doc) => {
    try {
      const res = await axios.get(`/uploads/company_documents/${doc.filename}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
        responseType: 'blob'
      });
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    } catch (e) {
      alert('Dosya açılırken hata oluştu.');
    }
  };

  return (
    <div className="company-detail-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px', color: '#fff' }}>
      <div style={{ background: 'rgba(255,255,255,0.03)', padding: '20px', borderRadius: '12px' }}>
        <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>Evrak Yükle</h3>
        <form onSubmit={handleUpload} style={{ marginBottom: 0 }}>
          <input type="text" placeholder="Etiket (Opsiyonel, örn. Sözleşme)" value={label} onChange={e => setLabel(e.target.value)} style={inputStyle} />
          <input id="company-doc-file-input" type="file" multiple onChange={e => setFiles(Array.from(e.target.files))} style={{ ...inputStyle, background: 'transparent', border: 'none', padding: 0 }} />
          <button type="submit" disabled={uploading || files.length === 0} style={{ ...btnStyle, background: 'linear-gradient(135deg, #F97316, #EA580C)', opacity: (uploading || files.length === 0) ? 0.6 : 1 }}>
            {uploading ? 'Yükleniyor...' : 'Yükle'}
          </button>
        </form>
      </div>
      <div>
        {loading ? <p>Yükleniyor...</p> : (
          data.length === 0 ? <div style={{ textAlign: 'center', color: '#6B7280', padding: '40px 0' }}>Henüz evrak yüklenmedi.</div> : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {data.map(doc => (
                <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px' }}>
                  <div style={{ fontSize: '22px' }}>{DOC_ICONS[doc.mime_type] || '📎'}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div onClick={() => handleView(doc)} style={{ fontSize: '13px', color: '#60A5FA', cursor: 'pointer', textDecoration: 'underline', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.original_name}
                    </div>
                    <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>
                      {doc.label ? doc.label + ' · ' : ''}{formatFileSize(doc.file_size)} · {new Date(doc.created_at).toLocaleDateString('tr-TR')}
                    </div>
                  </div>
                  <button onClick={() => handleDelete(doc.id)} style={delBtnStyle}>Sil</button>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  );
};

const CredentialsTab = ({ companyId }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingCred, setEditingCred] = useState(null);
  const [form, setForm] = useState({ label: '', username: '', password: '', url: '', notes: '' });
  const [revealed, setRevealed] = useState({});
  const [revealing, setRevealing] = useState(null);

  const authHeader = { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } };

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/credentials`, authHeader);
      setData(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); setRevealed({}); }, [companyId]);

  const resetForm = () => setForm({ label: '', username: '', password: '', url: '', notes: '' });
  const openNewForm = () => { setEditingCred(null); resetForm(); setShowForm(true); };
  const openEditForm = (cred) => {
    setEditingCred(cred);
    setForm({ label: cred.label, username: cred.username || '', password: '', url: cred.url || '', notes: cred.notes || '' });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingCred) {
        await axios.put(`/api/admin/company-credentials/${editingCred.id}`, form, authHeader);
      } else {
        await axios.post(`/api/admin/companies/${companyId}/credentials`, form, authHeader);
      }
      setShowForm(false);
      setEditingCred(null);
      resetForm();
      fetchData();
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.error || e.message));
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu şifre kaydını silmek istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`/api/admin/company-credentials/${id}`, authHeader);
      setRevealed(prev => { const n = { ...prev }; delete n[id]; return n; });
      fetchData();
    } catch (e) { console.error(e); }
  };

  const toggleReveal = async (id) => {
    if (revealed[id]) {
      setRevealed(prev => { const n = { ...prev }; delete n[id]; return n; });
      return;
    }
    try {
      setRevealing(id);
      const res = await axios.post(`/api/admin/company-credentials/${id}/reveal`, {}, authHeader);
      setRevealed(prev => ({ ...prev, [id]: res.data.password }));
    } catch (e) {
      alert('Şifre görüntülenemedi.');
    } finally {
      setRevealing(null);
    }
  };

  return (
    <div style={{ color: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, fontSize: '15px' }}>🔒 Şifre Kasası</h3>
        <button onClick={openNewForm} style={{ padding: '8px 16px', background: 'linear-gradient(135deg, #64748B, #334155)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>
          + Yeni Kayıt
        </button>
      </div>

      {loading ? <p>Yükleniyor...</p> : (
        data.length === 0 ? <div style={{ textAlign: 'center', color: '#6B7280', padding: '40px 0' }}>Henüz şifre kaydı yok.</div> : (
          <div style={{ overflowX: 'auto' }}>
          <table style={tableStyle}>
            <thead><tr><th>Etiket</th><th>Kullanıcı Adı</th><th>Şifre</th><th>URL</th><th>İşlem</th></tr></thead>
            <tbody>
              {data.map(cred => (
                <tr key={cred.id}>
                  <td>{cred.label}</td>
                  <td>{cred.username || '—'}</td>
                  <td style={{ fontFamily: 'monospace' }}>
                    {revealed[cred.id] ? revealed[cred.id] : '••••••••'}
                    <button onClick={() => toggleReveal(cred.id)} disabled={revealing === cred.id} style={{ marginLeft: 8, background: 'none', border: 'none', color: '#60A5FA', cursor: 'pointer', fontSize: '12px' }}>
                      {revealing === cred.id ? '...' : (revealed[cred.id] ? 'Gizle' : 'Göster')}
                    </button>
                  </td>
                  <td>{cred.url ? <a href={cred.url} target="_blank" rel="noreferrer" style={{ color: '#60A5FA' }}>{cred.url}</a> : '—'}</td>
                  <td style={{ display: 'flex', gap: '6px' }}>
                    <button onClick={() => openEditForm(cred)} style={{ padding: '4px 8px', background: 'rgba(59,130,246,0.1)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.2)', borderRadius: '6px', cursor: 'pointer' }}>Düzenle</button>
                    <button onClick={() => handleDelete(cred.id)} style={delBtnStyle}>Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )
      )}

      {showForm && (
        <div onClick={() => setShowForm(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#1A1A24', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '16px', padding: '24px', width: '420px', maxWidth: '90vw' }}>
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '15px' }}>{editingCred ? 'Şifre Kaydını Düzenle' : 'Yeni Şifre Kaydı'}</h3>
            <form onSubmit={handleSubmit}>
              <input required type="text" placeholder="Hizmet / Etiket (örn. Instagram Hesabı)" value={form.label} onChange={e => setForm({ ...form, label: e.target.value })} style={inputStyle} />
              <input type="text" placeholder="Kullanıcı Adı / E-posta" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} style={inputStyle} />
              <input required={!editingCred} type="text" placeholder={editingCred ? 'Yeni Şifre (boş bırakılırsa değişmez)' : 'Şifre'} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} style={inputStyle} />
              <input type="text" placeholder="URL (Opsiyonel)" value={form.url} onChange={e => setForm({ ...form, url: e.target.value })} style={inputStyle} />
              <textarea placeholder="Notlar (Opsiyonel)" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} style={{ ...inputStyle, height: '60px' }} />
              <button type="submit" style={{ ...btnStyle, background: 'linear-gradient(135deg, #64748B, #334155)' }}>{editingCred ? 'Güncelle' : 'Kaydet'}</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const ActivityLogTab = ({ companyId }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/admin/companies/${companyId}/activity-logs`, { headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });
      setLogs(res.data);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  useEffect(() => { fetchLogs(); }, [companyId]);

  if (loading) return <p style={{ color: '#9CA3AF' }}>Yükleniyor...</p>;

  return (
    <div style={{ color: '#fff' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3 style={{ margin: 0, fontSize: '15px' }}>📋 Aktivite Geçmişi</h3>
        <button onClick={fetchLogs} style={{ padding: '6px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', color: '#9CA3AF', cursor: 'pointer', fontSize: '12px' }}>
          ↻ Yenile
        </button>
      </div>
      {logs.length === 0 ? (
        <div style={{ textAlign: 'center', color: '#6B7280', padding: '40px 0' }}>Henüz bir aktivite kaydedilmedi.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {logs.map(log => (
            <div key={log.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', padding: '12px 16px', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '10px' }}>
              <div style={{ fontSize: '18px', lineHeight: '20px' }}>{ACTIVITY_ICONS[log.action] || '•'}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '13px', color: '#E5E7EB' }}>{log.description}</div>
                <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>
                  <strong style={{ color: '#60A5FA' }}>{log.admin_username || 'Bilinmeyen kullanıcı'}</strong>
                  {' · '}
                  {new Date(log.created_at).toLocaleString('tr-TR')}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const inputStyle = { width: '100%', padding: '10px 12px', background: 'rgba(26,26,36,0.6)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '8px', color: '#fff', fontSize: '14px', outline: 'none', marginBottom: '12px', boxSizing: 'border-box' };
const btnStyle = { width: '100%', padding: '10px', background: 'linear-gradient(135deg, #10b981, #059669)', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' };
const tableStyle = { width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' };
const delBtnStyle = { padding: '4px 8px', background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)', borderRadius: '6px', cursor: 'pointer' };

const CompanyDetail = ({ id, onBack }) => {
  const [activeTab, setActiveTab] = useState('calendar');

  return (
    <div style={{ padding: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
        <button 
          onClick={onBack} 
          style={{
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            color: '#9CA3AF',
            padding: '8px 16px',
            cursor: 'pointer',
            fontWeight: 500,
            transition: 'all 0.2s'
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#9CA3AF'; }}
        >
          &larr; Geri
        </button>
        <h2 style={{ fontSize: '20px', fontWeight: 700, margin: 0, color: '#E5E7EB' }}>
          Firma Yönetimi <span style={{ color: '#6B7280', fontSize: '14px', fontWeight: 500 }}>(ID: {id})</span>
        </h2>
      </div>
      
      <div style={{ display: 'flex', gap: '8px', marginBottom: '24px', background: 'rgba(17,17,24,0.6)', padding: '6px', borderRadius: '12px', width: 'fit-content', border: '1px solid rgba(255,255,255,0.06)' }}>
        <button 
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'calendar' ? 'linear-gradient(135deg, #10B981, #059669)' : 'transparent',
            color: activeTab === 'calendar' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('calendar')}
        >
          📅 Genel Takvim
        </button>
        <button 
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'appointments' ? 'linear-gradient(135deg, #3B82F6, #2563EB)' : 'transparent',
            color: activeTab === 'appointments' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('appointments')}
        >
          📝 Randevular
        </button>
        <button 
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'shoots' ? 'linear-gradient(135deg, #8B5CF6, #6366F1)' : 'transparent',
            color: activeTab === 'shoots' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('shoots')}
        >
          📸 Çekim Takvimi
        </button>
        <button 
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'finances' ? 'linear-gradient(135deg, #EF4444, #DC2626)' : 'transparent',
            color: activeTab === 'finances' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('finances')}
        >
          💰 Gelir / Gider
        </button>
        <button 
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'analytics' ? 'linear-gradient(135deg, #EC4899, #D946EF)' : 'transparent',
            color: activeTab === 'analytics' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('analytics')}
        >
          📊 Analiz
        </button>
        <button
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'activity' ? 'linear-gradient(135deg, #F59E0B, #D97706)' : 'transparent',
            color: activeTab === 'activity' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('activity')}
        >
          📋 Aktivite Geçmişi
        </button>
        <button
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'tasks' ? 'linear-gradient(135deg, #06B6D4, #0891B2)' : 'transparent',
            color: activeTab === 'tasks' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('tasks')}
        >
          🗂️ İş Takibi
        </button>
        <button
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'documents' ? 'linear-gradient(135deg, #F97316, #EA580C)' : 'transparent',
            color: activeTab === 'documents' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('documents')}
        >
          📁 Evraklar
        </button>
        <button
          style={{
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '13px',
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'all 0.2s',
            background: activeTab === 'credentials' ? 'linear-gradient(135deg, #64748B, #334155)' : 'transparent',
            color: activeTab === 'credentials' ? '#fff' : '#9CA3AF',
          }}
          onClick={() => setActiveTab('credentials')}
        >
          🔒 Şifreler
        </button>
      </div>

      <div style={{ background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '16px', padding: '32px', minHeight: '300px' }}>
        {activeTab === 'calendar' && <CompanyCalendar companyId={id} />}
        {activeTab === 'appointments' && <AppointmentsTab companyId={id} />}
        {activeTab === 'shoots' && <ShootingSchedulesTab companyId={id} />}
        {activeTab === 'finances' && <FinancesTab companyId={id} />}
        {activeTab === 'analytics' && <CompanyAnalytics companyId={id} />}
        {activeTab === 'activity' && <ActivityLogTab companyId={id} />}
        {activeTab === 'tasks' && <TasksTab companyId={id} />}
        {activeTab === 'documents' && <DocumentsTab companyId={id} />}
        {activeTab === 'credentials' && <CredentialsTab companyId={id} />}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .company-detail-grid { grid-template-columns: 1fr !important; }
          .company-kanban-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
};

export default CompanyDetail;
